import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaWallet, FaUserCircle, FaCog, FaCheck, FaSignOutAlt } from "react-icons/fa";
import Swal from "sweetalert2";

const AdvertiserHeader = ({ toggleSidebar, isProfileComplete }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    Swal.fire({
      title: "Logout Confirmation",
      text: "Are you sure you want to end your session?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#4f46e5",
      cancelButtonColor: "#ef4444",
      confirmButtonText: "Yes, Logout",
      background: "#ffffff",
      customClass: {
        popup: "rounded-3xl shadow-2xl",
        confirmButton: "rounded-xl font-bold px-6",
        cancelButton: "rounded-xl font-bold px-6",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        navigate("/login");
      }
    });
  };

  return (
    <header className="bg-white/80 backdrop-blur-md border-b border-slate-100 h-16 flex items-center justify-between px-4 sm:px-8 sticky top-0 z-40 transition-all">
      <div className="flex items-center gap-3">
        {/* Modern Mobile Toggle */}
        <button
          onClick={toggleSidebar}
          className="lg:hidden p-2 text-slate-500 hover:bg-slate-50 rounded-xl active:scale-90 transition-all border border-transparent hover:border-slate-100"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M4 6h16M4 12h8m-8 6h16" />
          </svg>
        </button>

        <div className="hidden lg:block">
          <h1 className="text-sm font-black text-slate-900 tracking-tight">Advertiser Command Center</h1>
        </div>
      </div>

      <div className="flex items-center gap-2 sm:gap-3">
        {/* Action Buttons with Premium Tooltips/Styles */}
        <div className="flex items-center bg-slate-50 p-1 rounded-xl border border-slate-100">
          <button
            onClick={() => navigate('/advertiser/wallet')}
            className="p-2 text-slate-500 hover:text-indigo-600 hover:bg-white hover:shadow-sm rounded-lg transition-all active:scale-90"
            title="Intelligence Wallet"
          >
            <FaWallet className="w-5 h-5" />
          </button>

          <button
            onClick={() => navigate('/advertiser/changepassword')}
            className="p-2 text-slate-500 hover:text-slate-900 hover:bg-white hover:shadow-sm rounded-lg transition-all active:scale-90"
            title="System Preferences"
          >
            <FaCog className="w-5 h-5" />
          </button>
        </div>

        <div className="h-6 w-px bg-slate-200 mx-1 hidden sm:block"></div>

        {/* Profile with Status Indicator */}
        <button
          onClick={() => navigate('/advertiser/profile')}
          className="group flex items-center gap-2 p-1 pr-3 bg-slate-900 text-white rounded-xl hover:bg-indigo-600 transition-all duration-300 active:scale-95 shadow-lg shadow-slate-200"
        >
          <div className="relative">
            <div className="w-8 h-8 rounded-lg bg-white/20 flex items-center justify-center backdrop-blur-sm group-hover:scale-110 transition-transform">
              <FaUserCircle className="w-5 h-5" />
            </div>
            {isProfileComplete && (
              <span className="absolute -top-1 -right-1 flex h-2.5 w-2.5">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-emerald-500 border-2 border-slate-900 group-hover:border-indigo-600 transition-colors"></span>
              </span>
            )}
          </div>
          <span className="text-[11px] font-black tracking-tight hidden sm:block uppercase">Account</span>
        </button>

        {/* Mobile Logout (Visible on small screens) */}
        <button
          onClick={handleLogout}
          className="lg:hidden p-2 text-rose-500 hover:text-white hover:bg-rose-500 rounded-lg transition-all active:scale-90 ml-1"
          title="Logout"
        >
          <FaSignOutAlt className="w-5 h-5" />
        </button>
      </div>
    </header>
  );
};

export default AdvertiserHeader;
